(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["blog-header"] && !Shopify.designMode) return;
  try {
    (() => {
    // the theme bundles this script on every page; only blog pages with the filter bar need the handlers
    if (!document.querySelector('.blog-filter')) return;
    const groups = () => document.querySelectorAll('details.blog-filter__group');
    document.addEventListener('click', (event) => {
      groups().forEach((group) => {
        if (group.open && !group.contains(event.target)) group.open = false;
      });
    });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      groups().forEach((group) => {
        if (group.open) {
          group.open = false;
          group.querySelector('summary')?.focus();
        }
      });
    });
    // one panel at a time, also in browsers without <details name>
    document.addEventListener(
      'toggle',
      (event) => {
        const opened = event.target;
        if (!(opened instanceof HTMLDetailsElement) || !opened.matches('.blog-filter__group') || !opened.open) return;
        groups().forEach((group) => {
          if (group !== opened) group.open = false;
        });
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["debug"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.debugCode').forEach((el) => {
      const codeEl = el.querySelector('code');
      let raw = codeEl.textContent;
      let output = raw;
      let type = 'unknown';
      try {
        const obj = JSON.parse(raw);
        if (Array.isArray(obj)) {
          type = 'array';
          output = JSON.stringify(obj, null, 2);
        } else if (typeof obj === 'string') {
          type = 'string';
          output = obj;
        } else if (obj === null) {
          type = 'null';
          output = 'null';
        } else if (typeof obj === 'number') {
          type = 'number';
          output = obj;
        } else if (typeof obj === 'boolean') {
          type = 'boolean';
          output = obj;
        } else if (typeof obj === 'object') {
          type = 'object';
          output = JSON.stringify(obj, null, 2);
        }
      } catch (e) {
        type = 'string';
        output = raw;
      }

      codeEl.textContent = output;
      el.setAttribute('data-type', type);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
